import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=4b301fc0&scoped=true"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../../scss/base.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./Recipe.vue?vue&type=style&index=2&id=4b301fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b301fc0",
  null
  
)

export default component.exports